import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { filter } from 'rxjs';

@Component({
  selector: 'login-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {

    public baseServiceUrl: string = environment.baseServiceUrl;

    constructor(protected authService: AuthService, protected router: Router, protected activatedRoute: ActivatedRoute,
        protected msalAuthService: MsalService, protected msalBroadcastService: MsalBroadcastService) { }

    private get returnUrl(): string {
        return this.activatedRoute.snapshot.queryParamMap.get('returnUrl') || '/projects';
    }

    public async ngOnInit(): Promise<void> {
        await this.authService.getUserInfo(true).subscribe({next: () => {
            if (this.authService.appUser != null && this.authService.appUser.username != null) {
                this.router.navigateByUrl(this.returnUrl);
            }
            this.msalBroadcastService.msalSubject$
                .pipe(filter((message: EventMessage) => message.eventType === EventType.LOGIN_SUCCESS))
                .subscribe((result: EventMessage) => {
                    this.router.navigateByUrl(this.returnUrl);
                    console.log(result);
                });
        }});
    }

    public login(): void {
        this.authService.login();
    }
}
